var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSignupStep3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/Steeper/03 ID Verfication") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 19.9999 0 19.9999 12.332 0 12.332"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "path-3",
    points: "0 0 19.9998 0 19.9998 12.352 0 12.352"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/Steeper/03-ID-Verfication",
    stroke: "none",
    strokeWidth: 1,
    fill: "current",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(0.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(0.000000, 7.668000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2209,12.332 L3.7789,12.332 C1.6959,12.332 -0.0001,10.636 -0.0001,8.553 L-0.0001,1 C-0.0001,0.447 0.4469,0 0.9999,0 C1.5529,0 1.9999,0.447 1.9999,1 L1.9999,8.553 C1.9999,9.534 2.7979,10.332 3.7789,10.332 L16.2209,10.332 C17.2019,10.332 17.9999,9.534 17.9999,8.553 L17.9999,7.689 C17.9999,7.136 18.4469,6.688 18.9999,6.688 C19.5529,6.688 19.9999,7.136 19.9999,7.689 L19.9999,8.553 C19.9999,10.636 18.3039,12.332 16.2209,12.332",
    id: "Fill-1",
    fill: "current"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9998,12.352 C18.4468,12.352 17.9998,11.905 17.9998,11.352 L17.9998,3.779 C17.9998,2.798 17.2018,2 16.2208,2 L3.7788,2 C2.7988,2 2.0008,2.798 2.0008,3.779 L2.0008,4.669 C2.0008,5.222 1.5528,5.669 0.9998,5.669 C0.4478,5.669 -0.0002,5.222 -0.0002,4.669 L-0.0002,3.779 C-0.0002,1.696 1.6958,0 3.7788,0 L16.2208,0 C18.3048,0 19.9998,1.696 19.9998,3.779 L19.9998,11.352 C19.9998,11.905 19.5528,12.352 18.9998,12.352",
    id: "Fill-4",
    fill: "current"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.0464,7.4662 L11.8324,7.4662 C11.2794,7.4662 10.8324,7.9032 10.8324,8.4432 C10.8324,8.9842 11.2794,9.4212 11.8324,9.4212 L15.0464,9.4212 C15.5994,9.4212 16.0464,8.9842 16.0464,8.4432 C16.0464,7.9032 15.5994,7.4662 15.0464,7.4662",
    id: "Fill-7",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0464,10.5787 L11.8324,10.5787 C11.2794,10.5787 10.8324,11.0157 10.8324,11.5557 C10.8324,12.0967 11.2794,12.5337 11.8324,12.5337 L15.0464,12.5337 C15.5994,12.5337 16.0464,12.0967 16.0464,11.5557 C16.0464,11.0157 15.5994,10.5787 15.0464,10.5787",
    id: "Fill-9",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.7845,9.9908 C7.5985,9.7938 8.1775,8.9968 8.0205,8.0928 C7.9055,7.4358 7.3835,6.8998 6.7285,6.7718 C5.6725,6.5658 4.7475,7.3698 4.7475,8.3888 C4.7475,9.1658 5.2855,9.8158 6.0085,9.9908 C4.8435,10.1768 3.9535,11.1838 3.9535,12.4008 L3.9535,12.4418 C3.9535,12.8938 4.3195,13.2598 4.7705,13.2598 L8.0225,13.2598 C8.4735,13.2598 8.8405,12.8938 8.8405,12.4418 L8.8405,12.4008 C8.8405,11.1838 7.9495,10.1768 6.7845,9.9908",
    id: "Fill-11",
    fill: "current"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignupStep3);
export default __webpack_public_path__ + "static/media/signup-step-3.7b0469b5623036383a777186d2f87fa1.svg";
export { ForwardRef as ReactComponent };